"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  data: function data() {
    return {
      center: {},
      currentPlace: null,
      markers: [],
      search: "",
      searchResult: ""
    };
  },
  props: {
    marker: {
      type: Object,
      default: function _default() {
        return {
          lat: 10.7884672,
          lng: 106.63047670000003
        };
      }
    }
  },
  watch: {
    marker: function marker(val) {
      var _this = this;
      console.log("coor", val);
      var marker = {
        lat: val.lat,
        lng: val.lng
      };
      this.markers = [];
      if (isNaN(val.lat) && isNaN(val.lng)) {
        return;
      }
      console.log("coor2", val);
      this.$nextTick(function () {
        _this.markers[0] = {
          position: marker
        };
        _this.center = marker;
      });
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    setPlace: function setPlace(place) {
      this.currentPlace = place;
      this.search = place.formatted_address;
      this.addMarker();
    },
    handleSearch: function handleSearch() {
      var _this2 = this;
      this.searchResult = this.search;
      this.$nextTick(function () {
        _this2.$refs.input_map.$refs.input.focus();
      });
    },
    addMarker: function addMarker() {
      if (this.currentPlace) {
        var marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.$emit("set:address", this.currentPlace.formatted_address);
        this.$emit("set:marker", marker);
        this.markers[0] = {
          position: marker
        };
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function geolocate() {
      var _this3 = this;
      navigator.geolocation.getCurrentPosition(function (position) {
        _this3.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    }
  }
};